import { isValidHttpUrl } from '../utils';

const isValidDocumentationUrl = (url: string) => {
  const trimmed = url.trim();

  return trimmed.length > 0 && isValidHttpUrl(trimmed);
};

export const canAddDocumentationUrlInput = (urls: string[]): boolean =>
  isValidDocumentationUrl(urls[0] ?? '');

export const areDocumentationUrlInputsValid = (urls: string[]): boolean =>
  urls.length > 0 && urls.every(isValidDocumentationUrl);

export const replaceDocumentationUrlAt = ({
  urls,
  index,
  value,
}: {
  urls: string[];
  index: number;
  value: string;
}): string[] =>
  urls.map((url, currentIndex) => (currentIndex === index ? value : url));

export const removeDocumentationUrlInputAt = ({
  urls,
  index,
}: {
  urls: string[];
  index: number;
}): string[] => {
  const nextUrls = urls.filter((_, currentIndex) => currentIndex !== index);

  return nextUrls.length === 0 ? [''] : nextUrls;
};

export const toDocumentationUrlDialogInputs = (urls: string[]): string[] =>
  urls.length > 0 ? [...urls] : [''];

export const isInvalidDocumentationUrlInput = (url: string): boolean => {
  const trimmed = url.trim();

  return trimmed.length > 0 && !isValidHttpUrl(trimmed);
};
